import { render } from "./DealHistory.vue?vue&type=template&id=47ffb860&scoped=true&ts=true"
import script from "./DealHistory.vue?vue&type=script&lang=ts"
export * from "./DealHistory.vue?vue&type=script&lang=ts"

import "./DealHistory.vue?vue&type=style&index=0&id=47ffb860&scoped=true&lang=css"

import exportComponent from "/home/runner/work/angelleague-front/angelleague-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47ffb860"]])

export default __exports__